import { render, staticRenderFns } from "./MigrationAvatar.vue?vue&type=template&id=d9dd517c&scoped=true&"
import script from "./MigrationAvatar.vue?vue&type=script&lang=js&"
export * from "./MigrationAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MigrationAvatar.vue?vue&type=style&index=0&id=d9dd517c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dd517c",
  null
  
)

export default component.exports